export enum OralMicrobialExaminationChartFields {
  microbialTypes1 = 'microbialTypes1',
  microbialTypes2 = 'microbialTypes2',
  microbialQuantity1 = 'microbialQuantity1',
  microbialQuantity2 = 'microbialQuantity2',
  microbialActivity1 = 'microbialActivity1',
  microbialActivity2 = 'microbialActivity2',
}

export enum MicrobialTypes {
  round1_type1 = 'round1_type1',
  round1_type2 = 'round1_type2',
  round1_type3 = 'round1_type3',
  round1_type4 = 'round1_type4',
  round2_type1 = 'round2_type1',
  round2_type2 = 'round2_type2',
  round2_type3 = 'round2_type3',
  round2_type4 = 'round2_type4',
}

export const MicrobialTypes1Label = {
  [MicrobialTypes.round1_type1]: '구균',
  [MicrobialTypes.round1_type2]: '간균',
  [MicrobialTypes.round1_type3]: '나선균',
  [MicrobialTypes.round1_type4]: '기타',
};

export const MicrobialTypes2Label = {
  [MicrobialTypes.round2_type1]: '구균',
  [MicrobialTypes.round2_type2]: '간균',
  [MicrobialTypes.round2_type3]: '나선균',
  [MicrobialTypes.round2_type4]: '기타',
};

export const OralMicrobialExaminationChartFormDefaultValues = {
  [OralMicrobialExaminationChartFields.microbialTypes1]: [],
  [OralMicrobialExaminationChartFields.microbialTypes2]: [],
  [OralMicrobialExaminationChartFields.microbialQuantity1]: '',
  [OralMicrobialExaminationChartFields.microbialQuantity2]: '',
  [OralMicrobialExaminationChartFields.microbialActivity1]: '',
  [OralMicrobialExaminationChartFields.microbialActivity2]: '',
};

export const AttachmentFilesDefaultValues = {
  0: null,
  1: null,
};
